import { Check, Circle } from 'lucide-react';

import { usePasswordPolicy } from '@/hooks/use-password-policy';
import { cn } from '@/utils/styles';

export type PasswordRequirementsProps = {
  /** The current password value to evaluate against the policy. */
  password: string;
};

/**
 * Live checklist of the platform password-policy rules, showing which are met
 * and which are still missing as the user types.
 */
export const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  const { getRequirements } = usePasswordPolicy();
  const requirements = getRequirements(password);

  return (
    <ul className="flex flex-col gap-1" aria-label="Password requirements">
      {requirements.map(({ code, label, met }) => (
        <li
          key={code}
          data-met={met}
          className={cn('flex items-center gap-1.5 text-xs', met ? 'text-emerald-400' : 'text-white/40')}
        >
          {met ? (
            <Check className="size-3.5 shrink-0" aria-hidden />
          ) : (
            <Circle className="size-3.5 shrink-0" aria-hidden />
          )}
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
};
